import { Country } from './../../models/country.model';
import { Observable } from 'rxjs';
import { publishReplay, refCount } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import {HttpClientService} from '../httpClient/httpclient.service';
import 'rxjs/Rx';
import { MessageService } from 'primeng/api';
import {UsersService} from '../user/users.service';

@Injectable()
export class CountryService {

  //countries: Country[];
  //countryEditing: Country;

  private cachedFields: Observable<any>;

  constructor (
    private h: HttpClientService,
    private srvNotify: MessageService,
    private usersSrv: UsersService
  ) { }

  list(
    offset = null,
    limit = null,
    search?: Array<{ key: string, value: string }>,
    globalSearch?: string,
    sort?: string,
    sort_dir?: number
  ): Observable<any> {
    const params = HttpClientService.buildListParams(offset, limit, search, globalSearch, sort, sort_dir);
    return this.h.getPaged('/koncentro-common/geo/countries' +
      (params.toString() ? '?' + params.toString().replace(/\+/gi, '%2B').replace(/'/gi, "''") : '' ));
  }

  getAll(includeDeleted = false) {
    let url = includeDeleted ? '/koncentro-common/geo/countries' : '/koncentro-common/geo/countries?flg_state=0';

    return this.h.get(url);
    /*
      .map(res => {
        return this.countries = res;
      });
      */
  }

  delete(record) {
    return this.h.delete('/koncentro-common/geo/countries/' + record.id)
      .map(res => {
        /*this.countries.splice(this.countries.indexOf(record), 1);*/
        this.srvNotify.add({severity: 'info', summary: 'Confirmed', detail: 'Country deleted'});
      });
  }

  post(newData) {
    return this.h.post('/koncentro-common/geo/countries/', newData)
      .map(res => {
        /*
        newData["id"] = res.id;
        this.countries.push(newData);
        */
        this.srvNotify.add({severity: 'info', summary: 'Success', detail: 'Operation success'});
      });

  }

  put(newData, doUpdateCountryEditing = true) {
    return this.h.put('/koncentro-common/geo/countries/', newData)
      .map(res => {
        /*
        if (doUpdateCountryEditing) {
          Object.assign(this.countryEditing, newData);
        }
      */
        this.srvNotify.add({severity: 'info', summary: 'Success', detail: 'Operation success'});
      });
  }

  recover(record) {
    return this.h.put('/koncentro-common/geo/countries/' + record.id + '/recover', {})
      .map(res => {
        this.srvNotify.add({severity: 'info', summary: 'Confirmed', detail: 'Country recovered'});
      });
  }

  getFields() {
    if (!this.cachedFields) {
      this.cachedFields = this.h.get('/koncentro-common/schema/CountryDto').pipe(
        publishReplay(1), // this tells Rx to cache the latest emitted
        refCount() // and this tells Rx to keep the Observable alive as long as there are any Subscribers
      )
    }
    return this.cachedFields;
  }
}



// WEBPACK FOOTER //
// ./src/app/services/country/country.service.ts